import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../../core/constants/api-endpoints';
import { IResponse, IUser, Payload } from '../../core/constants/interfaces';
import { LoginCredentials } from '../../core/models/login-credentials';
import { HTTPClientService } from '../../core/utils/httpclient.service';
import { AdminService } from '../../dashboard/pages/admin/admin.service';
import { LoginComponent } from '../components/login/login.component';
import { Role } from '../../core/enums/roles.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticated = false;
  private user: Payload;

  constructor(
    private router: Router,
    private adminService: AdminService,
    private cookieService: CookieService,
    private http: HTTPClientService,
    private dialog: MatDialog
  ) {
    const authToken = this.cookieService.get('auth_token');
    this.isAuthenticated = authToken !== null && authToken !== '';
    this.user = JSON.parse(localStorage.getItem('user') ?? '{}');
  }
  getUser(): Payload {
    return this.user;
  }

  hasAdminAccess(role?: string): boolean {
    const userRole = role || this.user?.role;
    return userRole === Role.ADMIN || userRole === Role.SUPER_ADMIN;
  }

  /** Broadcasts (DEMO1-362) and other platform-wide actions are SUPER_ADMIN-only. */
  isSuperAdmin(): boolean {
    return this.user?.role === Role.SUPER_ADMIN;
  }

  getUserFromDB(): Observable<IUser> {
    return this.http.get<IUser>(`users/${this.user.id}`);
  }
  login(credentials: LoginCredentials): Observable<IResponse> {
    const body = {
      emailAddress: credentials.emailAddress,
      password: credentials.password,
    };

    return this.http.post<IResponse>(API_ENDPOINTS.AUTH.LOGIN, body);
  }
  isLoggedIn(): boolean {
    // const authToken = this.cookieService.get('auth_token');
    // this.isAuthenticated = authToken !== null && authToken !== '';
    return this.isAuthenticated;
  }

  getAuthToken(): string | null {
    return this.cookieService.get('auth_token') || null;
  }
  refreshUser(): void {
    if (!this.user || !this.user.id) return;

    this.getUserFromDB().subscribe({
      next: (updatedUser) => {
        const updatedUserPayload: Payload = {
          ...this.user,
          ...updatedUser,
          profile_pic: updatedUser.photo,
          photo: {
            id: updatedUser.photo,
            photo: updatedUser.photo ? [updatedUser.photo] : [],
            contentType: updatedUser.photoContentType,
            url: '',
          },
        };

        updatedUserPayload.role = updatedUserPayload.role || 'USER';

        this.user = updatedUserPayload;
        localStorage.setItem('user', JSON.stringify(this.user));
      },
      error: (error) => {
        console.error('Failed to refresh user data:', error);
      },
    });
  }

  logout(): void {
    this.isAuthenticated = false;
    localStorage.removeItem('user');
    this.cookieService.delete('auth_token', '/');
    localStorage.removeItem('reloadForLogin');
    this.router.navigate(['/auth/login']);
  }
  openLoginDialog() {
    this.dialog.open(LoginComponent, {
      width: '900px',
      height: '600px',
      maxWidth: '90vw',
      panelClass: 'custom-dialog-container',
      data: { email: '' },
    });
  }
}
